import { History } from 'history';
import { ReactNode } from 'react';
import { PX_STATE } from '../../../routes/paths';
import {
    EL_ID_MH,
    EL_ID_VITALS,
    MEDICAL_RECORDS,
    PAST_VISIT_VITALS,
} from './magicBoxTableElements';
import { changePathAndFocus } from './magicBoxUtils';
import MH from './MH';
import MR from './MR';
import Visits from './Visits';
import Vitals from './Vitals';
import { ALL_PAST_VISIT } from '../../../components/prescriptionPad/rightPanel/workspace/AllPastVisit';
import { useSelector } from 'react-redux';
import { getPatientDetailsVisits } from '../../../store/selectors/prescriptionPad';

const PastVisitLabel: React.FC = () => {
    const patientDetails = useSelector(getPatientDetailsVisits);

    return (
        <span>
            See all Past Visits{' '}
            {patientDetails && patientDetails?.data?.length
                ? `[${patientDetails.data.length}]`
                : ''}
        </span>
    );
};

export const configs: {
    [k: string]: {
        initial: string;
        label: string;
        seeAllText: ReactNode;
        component: ReactNode;
        elId: string;
        focus: (history: History, pxId: string, pxState: PX_STATE) => void;
    };
} = {
    visits: {
        initial: 'P',
        label: 'Past Visits',
        seeAllText: <PastVisitLabel />,
        component: <Visits />,
        elId: ALL_PAST_VISIT,
        focus: (history: History, pxId: string, pxState: PX_STATE) => {
            changePathAndFocus(ALL_PAST_VISIT, history, pxId, pxState, 'patient-overview');
        },
    },
    mh: {
        initial: 'H',
        label: 'History',
        seeAllText: 'See all History',
        component: <MH />,
        elId: EL_ID_MH,
        focus: (history: History, pxId: string, pxState: PX_STATE) => {
            changePathAndFocus(EL_ID_MH, history, pxId, 'edit');
        },
    },
    vitals: {
        initial: 'V',
        label: 'Vitals',
        seeAllText: 'See all vitals & investigations',
        component: <Vitals />,
        elId: EL_ID_VITALS,
        focus: (history: History, pxId: string, pxState: PX_STATE) => {
            changePathAndFocus(PAST_VISIT_VITALS, history, pxId, pxState, 'patient-overview');
        },
    },
    mr: {
        initial: 'R',
        label: 'Records',
        seeAllText: 'See all Records',
        component: <MR />,
        elId: MEDICAL_RECORDS,
        focus: (history: History, pxId: string, pxState: PX_STATE) => {
            changePathAndFocus(
                MEDICAL_RECORDS,
                history,
                pxId,
                pxState,
                'medical-records',
                undefined,
                undefined,
                true,
            );
        },
    },
};
